import { TUser } from '../../../models/common';
import helperService from '../../../services/helper.service';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import style from './members-list-item.module.scss';
import { useNavigate } from 'react-router-dom';

interface MembersSearchItemProps {
  user: TUser;
}

function MembersListItem({ user }: MembersSearchItemProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(helperService.getNavigateLink(user));
  };
  return (
    <div onClick={handleNavigate} key={user._id} className={style['search-members-item']}>
      <ProfilePhoto user={user} className={style.avatar}/>
      <div className={style['user-info']}>
        <div className={style['username']}>{user.username}</div>
        <div className={style['bio']}>{user.biography}</div>
      </div>
    </div>
  );
}

export default MembersListItem;
